/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkstationUpdate
 */
export interface WorkstationUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof WorkstationUpdate
     */
    report?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof WorkstationUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkstationUpdate
     */
    hostname: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkstationUpdate
     */
    lastSeen?: Date | null;
}

export function WorkstationUpdateFromJSON(json: any): WorkstationUpdate {
    return WorkstationUpdateFromJSONTyped(json, false);
}

export function WorkstationUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkstationUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report': !exists(json, 'report') ? undefined : json['report'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'hostname': json['hostname'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (json['last_seen'] === null ? null : new Date(json['last_seen'])),
    };
}

export function WorkstationUpdateToJSON(value?: WorkstationUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report': value.report,
        'name': value.name,
        'hostname': value.hostname,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen === null ? null : value.lastSeen.toISOString()),
    };
}


